import { RECEIVE_PRODUCTION_STEPS, PRODUCTION_STEPS_ERROR } from "../actions/productionStepsActions";

const initialProductionStepsState = {};

export const productionStepsReducer = (state = initialProductionStepsState, action) => {
	switch (action.type) {
		case RECEIVE_PRODUCTION_STEPS:
			// adds production step to store by provided title
			return { ...state, [action.title]: action.payload };
		case PRODUCTION_STEPS_ERROR:
			return { ...state, error: action.payload };
		default:
			return state;
	}
};
